import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { login } from '../features/authSlice';
import { useLoginMutation } from '../services/authApi';
import LoginPage, { Username, Password, Submit, Title, Logo, Reset } from '@react-login-page/base';
import LoginLogo from 'react-login-page/logo-rect';
import './Login.css';
import dziennikLogo from '../logo.png';

const Login = () => {
  const dispatch = useDispatch();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const [loginMutation, { isLoading }] = useLoginMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = await loginMutation({ username, password }).unwrap();

      if (data.token) {

        dispatch(login(data.token));

        localStorage.setItem('token', data.token);
        window.location.href = '/dashboard';
      } else {
        setError(data.error || 'Nieznany błąd');
      }
    } catch (err) {
      const status = err?.status ?? err?.data?.status ?? null;
      if (status === 401) {
        setError('Błędny login lub hasło');
      } else {
        setError(err?.data?.error || err?.error || 'Nieznany błąd');
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page-base">
        <LoginPage onSubmit={handleSubmit}>
          <Username name="username" onChange={(e) => setUsername(e.target.value)} onKeyDown={handleKeyDown} placeholder='Login' />
          <Password name="password" onChange={(e) => setPassword(e.target.value)} onKeyDown={handleKeyDown} placeholder='Hasło' />
          <Submit onClick={handleSubmit}>Zaloguj się</Submit>
          <Reset disabled={true} visible={false}></Reset>
          <Title visible={false}/>
          <Logo>
            <img src={dziennikLogo} alt="React Logo" style={{ height: '50px' }} />
          </Logo>
          {error && <p style={{ color: 'red' }}>{error}</p>}
        </LoginPage>
      </div>
    </div>
  );
};

export default Login;
